import email from '../assets/email.png';
import mobile from '../assets/mobile.png';
import api from '../assets/api.png';
import cpp from '../assets/cpp.png';
import css from '../assets/css.png';
import git from '../assets/git.png';
import html from '../assets/html.png';
import javascript from '../assets/javascript.png';
import mu5 from '../assets/mu5.png';
import node from '../assets/node.png';
import python from '../assets/python.png';
import react from '../assets/react.png';
import redux from '../assets/redux.png';
import sass from '../assets/sass.png';
import solidity from '../assets/solidity.png';
import jquery from '../assets/jquery.png';
import bubble from '../assets/bubble.png';
import tailwind from '../assets/tailwind.png';
import bootstrap from '../assets/bootstrap.png';
import materialui from '../assets/materialui.png';
import syncfusion from '../assets/syncfusion.png';
import mysql from '../assets/mysql.png';
import mee from '../assets/mee.png';


import about01 from '../assets/about01.png';
import about02 from '../assets/about02.png';
import about03 from '../assets/about03.png';
import about04 from '../assets/about04.png';
import heroimage from '../assets/heroimage.png';
import heroimg from '../assets/heroimg.png';

import profile from '../assets/profile.jpg';

import php from '../assets/php.png';
import sanity from '../assets/sanity.png';
import nb from '../assets/nb.png';
import wordpress from '../assets/wordpress.png';
import mongodb from '../assets/mongodb.png';

export default {
  email,
  mobile,
  solidity,
  jquery,
  mee,
  api,
  cpp,
  css,
  git,
  html,
  javascript,
  mu5,
  heroimage,
  heroimg,
  node,
  python,
  react,
  redux,
  sass,
  sanity,
  bubble,
  mysql,
  tailwind,
  bootstrap,
  syncfusion,
  materialui,
  php,
  mongodb,
  wordpress,
  about01,
  about02,
  about03,
  about04,
  profile,
  nb,
  
};
